import Phaser from 'phaser';

const DEFAULT_WORLD_WIDTH = 3840;
const MIN_Y = 120;
const MAX_Y = 500;

export default class JellyfishSystem {
  constructor(scene, options = {}) {
    this.scene = scene;
    this.worldWidth = options.worldWidth ?? DEFAULT_WORLD_WIDTH;
    this.jellyfish = [];
  }

  create(count = 6) {
    for (let index = 0; index < count; index += 1) {
      this.createJellyfish(index);
    }
  }

  createJellyfish(index) {
    const x = Phaser.Math.Between(260, this.worldWidth - 260);
    const y = Phaser.Math.Between(MIN_Y, MAX_Y);
    const scale = Phaser.Math.FloatBetween(0.65, 1.1);

    const container = this.scene.add.container(x, y);
    container.setDepth(index % 3 === 0 ? 1.1 : 0.8);
    container.setAlpha(Phaser.Math.FloatBetween(0.55, 0.82));
    container.setScale(scale);

    const glow = this.scene.add.ellipse(0, 0, 58, 46, 0x67e8f9, 0.12);
    const bell = this.scene.add.ellipse(0, 0, 38, 28, 0xa5f3fc, 0.72);
    const inner = this.scene.add.ellipse(0, 2, 24, 17, 0x22d3ee, 0.32);

    const tentacles = [];
    for (let tentacleIndex = 0; tentacleIndex < 4; tentacleIndex += 1) {
      const tentacle = this.scene.add.rectangle(
        -12 + tentacleIndex * 8,
        24,
        3,
        28 + Phaser.Math.Between(0, 12),
        0xa5f3fc,
        0.48
      );
      tentacle.setOrigin(0.5, 0);
      tentacles.push(tentacle);
    }

    container.add([glow, ...tentacles, bell, inner]);

    container.jellyData = {
      baseY: y,
      phase: Math.random() * Math.PI * 2,
      driftSpeed: Phaser.Math.FloatBetween(8, 18),
      verticalSpeed: Phaser.Math.FloatBetween(0.55, 1.05),
      verticalAmount: Phaser.Math.FloatBetween(18, 38),
      direction: Math.random() > 0.5 ? 1 : -1,
      scale,
      bell,
      glow,
      tentacles,
    };

    this.jellyfish.push(container);
  }

  update(time, delta) {
    const seconds = Math.min(delta, 40) / 1000;

    this.jellyfish.forEach((jelly) => {
      if (!jelly.active || !jelly.jellyData) {
        return;
      }

      const data = jelly.jellyData;
      data.phase += data.verticalSpeed * seconds;

      jelly.x += data.direction * data.driftSpeed * seconds;
      jelly.y = data.baseY + Math.sin(data.phase) * data.verticalAmount;

      const pulse = 1 + Math.sin(time * 0.004 + data.phase) * 0.08;
      jelly.setScale(data.scale * pulse, data.scale * (2 - pulse));
      jelly.rotation = Math.sin(data.phase * 0.7) * 0.05;

      data.glow.setAlpha(0.1 + (pulse - 0.92) * 0.45);
      data.bell.setAlpha(0.62 + (pulse - 0.92) * 0.8);

      data.tentacles.forEach((tentacle, index) => {
        tentacle.rotation = Math.sin(data.phase * 1.8 + index * 0.8) * 0.16;
        tentacle.scaleY = 0.9 + Math.sin(data.phase * 1.4 + index) * 0.12;
      });

      if (jelly.x < -100) {
        jelly.x = this.worldWidth + 100;
      } else if (jelly.x > this.worldWidth + 100) {
        jelly.x = -100;
      }
    });
  }

  destroy() {
    this.jellyfish.forEach((jelly) => {
      if (jelly?.active) {
        jelly.destroy(true);
      }
    });

    this.jellyfish = [];
  }
}
